import React from 'react';
import {
  AutoBookCreateContainer,
  availableApointments,
  getAutoBookContainerData,
  getContainerData,
  NewAppointmentsFilter,
  SaveApiResMessage,
} from '@/actions';
import { Icons } from '@/assets';
import LoadingV2 from '@/components/Loading';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import AppointmentTable from '@/ctComponents/AppointmentTable';
import CardContainer from '@/ctComponents/CardContainer/CardContainer';
import IconButton from '@/ctComponents/IconButton';
import Modal from '@/ctComponents/Modal';
import PaginationButtons from '@/ctComponents/PaginationButtons';
import TableEx from '@/ctComponents/TableEx/Table';
import { formatDateToUTC } from '@/ctUtlis/formatDate';
import EditAppointmentModal from '@/screens/Appointments/EditAppointmentModal';
import AutobookList from '@/screens/Autobook/AutobookList';
import { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import { ReactSVG } from 'react-svg';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { usePusher } from '../../../App';
import BookedCard from './bookedCard/bookedCard';
import StatusSelector from './StatusSelector';
import styles from './style.module.css';

export default (recivedApiData) => {
  const isAutobookPage = recivedApiData?.apiData ? true : false;
  const { channels } = usePusher();
  const location = useLocation();
  const [selectedStatus, setSelectedStatus] = useState('NORMAL');
  const queryParams = new URLSearchParams(location.search);
  const [apiData, setApiData] = useState(
    recivedApiData?.apiData
      ? recivedApiData?.apiData
      : queryParams.get('apiData')
      ? JSON.parse(queryParams.get('apiData'))
      : {}
  );
  const [editSizeAndSsl, setEditSizeAndSsl] = useState(
    queryParams.get('editSizeAndSsl')
  );
  const [autobookID, setAutobookID] = useState(null);
  const [loading, setLoading] = useState(false);
  const parentRef = useRef(null);
  const [containerData, setContainerData] = useState([]);
  const [cabinId, setCabinId] = useState();
  const [appointmentData, setAppointmentData] = useState(null);
  const [appointmentSet, setAppointmentSet] = useState([]);
  const [shift, setShift] = useState(true);
  const [show, setShow] = useState(false);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [SSLOptions, setSSLOptions] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showAutoBookModal, setShowAutoBookModal] = useState(false);
  const showAutoBookModalRef = useRef(false);
  const shouldRefreshAfterModalCloseRef = useRef(false);
  // Sample state for AutobookList modal (replace with your API logic)
  const [autobookTableData, setAutobookTableData] = useState({});
  const [autobookSettings, setAutobookSettings] = useState({});
  const [autobookStatus, setAutobookStatus] = useState('DISABLED');
  const [autobookMode, setAutobookMode] = useState({
    status: false,
    autobookId: null,
  });
  const [autobookModeapiRes, setAutobookModeapiRes] = useState({
    status: false,
    autobookId: null,
  });
  const [autobookAppointmentsApiData, setAutobookAppointmentsApiData] =
    useState({});
  const [autobookSavingIdentifier, setAutobookSavingIdentifier] = useState('');
  const [autobookHistoryList, setAutobookHistoryList] = useState([]);
  const [autobookLoading, setAutobookLoading] = useState(false);
  const [autobookModeLoading, setAutobookModeLoading] = useState(false);
  const [autobookActiveSection, setAutobookActiveSection] = useState('hour');
  const [autobookSavedTemplates, setAutobookSavedTemplates] = useState([]);
  const [autobookShowSavePreferences, setAutobookShowSavePreferences] =
    useState(false);
  const [autobookPreferenceName, setAutobookPreferenceName] = useState('');
  const [autobookClickedTemplate, setAutobookClickedTemplate] = useState(null);

  let sliderRef = useRef(null);

  const sortByStatus = (data) => {
    const getStatusPriority = (status) => {
      if (status === 'PENDING_EDIT') {
        return 1;
      }
      if (status === 'PENDING_RESERVE') {
        return 1;
      }
      if (status === 'PENDING_CANCEL') {
        return 1;
      }

      if (status === 'USED') {
        return 2;
      }

      if (status === 'RESERVED' || status === 'EDITED') {
        return 3;
      }

      return 4;
    };

    return Object.fromEntries(
      Object.entries(data)
        .sort((a, b) => {
          const statusA = a[1].status || '';
          const statusB = b[1].status || '';
          const priorityA = getStatusPriority(statusA);
          const priorityB = getStatusPriority(statusB);

          // First compare by status priority
          if (priorityA !== priorityB) {
            return priorityA - priorityB;
          }

          // If status is the same, compare by updated_at (newest first)
          const updatedAtA = new Date(a[1].updated_at || 0);
          const updatedAtB = new Date(b[1].updated_at || 0);
          return updatedAtB - updatedAtA; // Descending order (newest first)
        })
        .map(([k, v]) => [`key_${k}`, v])
    );
  };
  const sortedData = sortByStatus(appointmentSet);

  useEffect(() => {
    if (channels?.publicChannel) {
      const handleUpdateData = (data) => {
        // console.log(
        //   'received data from pusher',
        //   data,
        //   'apiData',
        //   apiData,
        //   'cabinId',
        //   cabinId || apiData?.cabinId
        // );
        const pusherUpdateMessage = data.message;
        if (
          (pusherUpdateMessage.specificationId === apiData?.size &&
            pusherUpdateMessage.sslId === apiData?.ssl) ||
          pusherUpdateMessage.cabinId === (cabinId || apiData?.cabinId)
        ) {
          // If modal is open, don't refresh UI/data yet.
          // We'll refresh once after modal close instead.
          if (showAutoBookModalRef.current) {
            shouldRefreshAfterModalCloseRef.current = true;
            return;
          }
          getApointment();
          getAutobookPreferences(autobookID);
        }
      };

      channels.publicChannel.bind(
        'AppointmentAvailabilityUpdated',
        handleUpdateData
      );

      return () => {
        channels.publicChannel.unbind(
          'AppointmentAvailabilityUpdated',
          handleUpdateData
        );
      };
    }
  }, [channels, apiData]);

  const handlePageChange = (newPage, direction) => {
    if (direction === 'next') {
      sliderRef.slickNext();
    } else if (direction === 'prev') {
      sliderRef.slickPrev();
    } else {
      // Go to specific page
      const currentSlidesToShow = getCurrentSlidesToShow();
      const slideIndex = (newPage - 1) * currentSlidesToShow;
      sliderRef.slickGoTo(slideIndex);
    }
  };

  // Function to get current slidesToShow based on screen size and page type
  const getCurrentSlidesToShow = () => {
    const screenWidth = window.innerWidth;

    if (isAutobookPage) {
      // Autobook page responsive breakpoints
      if (screenWidth >= 1900) {
        return 3;
      } else if (screenWidth >= 1330) {
        return 2;
      } else {
        return 1;
      }
    } else {
      // Non-autobook page responsive breakpoints
      if (screenWidth >= 1974) {
        return 3;
      } else {
        return 2;
      }
    }
  };

  // Calculate total pages based on current slidesToShow
  const getTotalPages = () => {
    const currentSlidesToShow = getCurrentSlidesToShow();
    return Math.ceil(
      Object.entries(appointmentSet).length / currentSlidesToShow
    );
  };

  // Listen for container update events from Redux (populated by AppBar)
  const containerUpdateEvent = useSelector(
    (state) => state.reducer?.containerUpdateEvent
  );

  const extractSimpleContainers = (resArray) => {
    return resArray.map((item) => ({
      size: `${item.size?.size}-${item.size?.name}-${item.size?.model}`,
      ssl: item.ssl?.name || null,
      location: item.location?.city || null,
      lfd: item?.lfd ? formatDateToUTC(item?.lfd) : '',
      aptType: item.aptType === 'SINGLE' ? 'None' : item.aptType,
      chassesType:
        item.chassesType === 0 ? 'Pool' : item.chassesType === 1 ? 'Own' : '-',
      terminalApt: item.terminalApt ?? 'No Apt.',
      name: item.name,
      id: item.id,
      chases: item.chases,
      status: item.status,
      gated_in: item.gated_in,
      gated_out: formatDate(item.gated_out),
      isLiveUnload: item.isLiveUnload,
    }));
  };

  const formatDate = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    const time = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
    });
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(2);
    return `${time}   ${mm}-${dd}-${yy}`;
  };

  const getContainerDataHandler = useCallback(
    (EdittedqueryParamsJson) => {
      const currentApiData = EdittedqueryParamsJson || apiData;
      if (currentApiData?.isLiveUnload) {
        setCabinId(currentApiData?.cabinId);

        getApointment(EdittedqueryParamsJson);
      } else {
        getContainerData([currentApiData?.containerId])
          .then((res) => {
            const simpleData = extractSimpleContainers([res.containerData]);
            setContainerData(simpleData);
            setCabinId(res.containerData.cabin_id);

            getApointment(EdittedqueryParamsJson);
          })
          .catch((err) => {
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      }
    },
    [apiData]
  );

  const getApointment = useCallback(
    (EdittedqueryParamsJson) => {
      const currentApiData = EdittedqueryParamsJson || apiData;
      availableApointments({
        ...currentApiData,
        newAppointment: false,
      }).then((res) => {
        setAutobookMode({
          status: res?.autobook_on,
          autobookId: res?.autobook_id,
        });
        setAutobookModeapiRes({
          status: res?.autobook_on,
          autobookId: res?.autobook_id,
        });
        setAutobookID(res?.autobook_id);

        const { availability, terminals } = res;
        setShift(res.active_shift === 'shift1' ? true : false);
        if (res?.container_data) {
          setContainerData([
            {
              name: res?.container_data?.name,
              size: res?.container_data?.cabin?.specifications?.size_type,
              ssl: res?.container_data?.cabin?.company?.alias,
              cabinIsVerified: res?.container_data?.cabin_is_verified,
              containerEditable: res?.container_data?.container_editable,
            },
          ]);
        }

        const terminalSlugs = Object.fromEntries(
          Object.entries(terminals).map(([id, terminal]) => [id, terminal.slug])
        );

        Object.keys(terminals).forEach((terminalId) => {
          const terminalSlug = terminalSlugs[terminalId];
          terminals[terminalSlug] = {
            ...terminals[terminalId],
            gate_schedules: {},
          };
          delete terminals[terminalId];
          Object.keys(availability).forEach((date) => {
            terminals[terminalSlug].gate_schedules[date] = {};

            if (availability[date][terminalId]) {
              const shifts = availability[date][terminalId];

              Object.keys(shifts).forEach((shiftKey) => {
                const status = shifts[shiftKey].status;

                terminals[terminalSlug].gate_schedules[date][shiftKey] = {
                  single: status,
                  dual: status === 1 || status === 2 ? 1 : status,
                  available_count: shifts[shiftKey].available_count,
                  booked_count: shifts[shiftKey].booked_count,
                  bg_highlight: shifts[shiftKey].bg_highlight,
                  status: shifts[shiftKey].status,
                  gate_status: shifts[shiftKey].gate_status,
                  gate_update: shifts[shiftKey].gate_update,
                  restriction_status: shifts[shiftKey].restriction_status,
                  restriction_update: shifts[shiftKey].restriction_update,
                };
              });
            }
          });
        });
        setAppointmentData(Object.values(terminals));

        if (res?.containerAppointments) {
          // Get first appointment from each terminal
          const terminalAppointments = Object.entries(res.containerAppointments)
            .map(([terminalId, appointments]) => {
              const firstAppointment = appointments[0];
              return {
                [terminalId]: {
                  terminalId,
                  id: firstAppointment?.id,
                  status: firstAppointment?.status,
                  statusText: firstAppointment?.status_text,
                  lastCheckedAt: firstAppointment?.last_checked_at,
                  fromAutobook:
                    firstAppointment?.from_autobook === 1 ? true : false,
                  lastMessage: firstAppointment?.last_message,
                  date: firstAppointment?.terminal_appointment_availability?.date?.replace(
                    /(\d{2})-(\d{2})-(\d{4})/,
                    '$2/$1/$3'
                  ),
                  dateTocheck:
                    firstAppointment?.terminal_appointment_availability
                      ?.date_to_check,
                  terminal:
                    firstAppointment?.terminal_appointment_availability
                      ?.terminal?.slug,
                  time: `${firstAppointment?.terminal_appointment_availability?.time_start} - ${firstAppointment?.terminal_appointment_availability?.time_end}`,
                  type: firstAppointment?.type,
                  shift: Number(
                    firstAppointment?.terminal_appointment_availability?.shift?.replace(
                      /shift/,
                      ''
                    )
                  ),
                  selectId:
                    firstAppointment?.terminal_appointment_availability?.id,
                  license_plate: firstAppointment?.license_plate,
                  reserve_history: firstAppointment?.reserve_history || [],
                  terminal_name:
                    firstAppointment?.terminal_appointment_availability
                      ?.terminal?.name,
                  terminal_address:
                    firstAppointment?.terminal_appointment_availability
                      ?.terminal?.address,
                  terminal_website:
                    firstAppointment?.terminal_appointment_availability
                      ?.terminal?.website,
                  terminal_links:
                    firstAppointment?.terminal_appointment_availability
                      ?.terminal?.links,
                  total_appointments: appointments.length,
                  updated_at: firstAppointment.updated_at,
                  origin_source: firstAppointment?.origin_source,
                },
              };
            })
            .reduce((acc, curr) => ({ ...acc, ...curr }), []);

          setAppointmentSet(terminalAppointments);
        }
      });
    },
    [apiData]
  );

  const handleAutobookModeChange = useCallback(() => {
    // Mark for refresh; actual call should happen on modal close.
    shouldRefreshAfterModalCloseRef.current = true;
    // If modal has already been closed, refresh immediately once.
    if (!showAutoBookModalRef.current) {
      shouldRefreshAfterModalCloseRef.current = false;
      getApointment();
    }
  }, [getApointment]);

  useEffect(() => {
    showAutoBookModalRef.current = showAutoBookModal;
  }, [showAutoBookModal]);

  const setShowAutoBookModalWithRefresh = useCallback(
    (next) => {
      const nextValue =
        typeof next === 'function' ? next(showAutoBookModalRef.current) : next;
      const isClosing = showAutoBookModalRef.current && nextValue === false;
      showAutoBookModalRef.current = nextValue;
      setShowAutoBookModal(nextValue);
      if (isClosing) {
        shouldRefreshAfterModalCloseRef.current = false;
        getApointment();
      }
    },
    [getApointment]
  );

  useEffect(() => {
    getContainerDataHandler();
  }, []);

  // Listen for container updates from AppBar's Pusher event
  useEffect(() => {
    // console.log({ apiData });
    if (
      containerUpdateEvent?.message?.container_id === apiData?.containerId ||
      containerUpdateEvent?.message?.container === apiData?.containerId
    ) {
      getContainerDataHandler();
    }
  }, [containerUpdateEvent]);

  // Listen for queryParams changes (when navigating from notifications)
  useEffect(() => {
    const newQueryParams = new URLSearchParams(location.search);
    const newApiData = newQueryParams.get('apiData')
      ? JSON.parse(newQueryParams.get('apiData'))
      : null;

    // Only update if there's actually apiData in the URL and it's different
    if (newApiData && JSON.stringify(newApiData) !== JSON.stringify(apiData)) {
      // Update the apiData and refresh the page data
      setApiData(newApiData);
      setLoading(true);
      // Use the new apiData directly
      getContainerDataHandler(newApiData);
    }
  }, [location.search]);

  // // Listen for window resize to update pagination
  // useEffect(() => {
  //   const handleResize = () => {
  //     // Update pagination when screen size changes
  //     const totalPages = getTotalPages();
  //     if (activeSlide > totalPages && totalPages > 0) {
  //       setActiveSlide(totalPages);
  //     }
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, [activeSlide]);

  const onClickeditSizeAndSsl = () => {
    NewAppointmentsFilter({
      company: null,
      specifiation: null,
    }).then((res) => {
      setSizeOptions(
        res.data.specifications.map(({ id, size, name, model }) => ({
          value: id,
          label: `${size}${name ? '-' + name : ''}-${model}`,
        }))
      );
      setSSLOptions(
        res.data.companies.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
      );
    });
    setShow(true);
  };

  const onClickeditSizeAndSslLoadContainers = (containerId, updateData) => {
    NewAppointmentsFilter({
      company: null,
      specifiation: null,
    }).then((res) => {
      setSizeOptions(
        res.data.specifications.map(({ id, size, name, model }) => ({
          value: id,
          label: `${size}${name ? '-' + name : ''}-${model}`,
        }))
      );
      setSSLOptions(
        res.data.companies.map(({ id, name }) => ({
          value: id,
          label: name,
        }))
      );
    });
    setShow(true);

    // notify('Updating container...');

    // // Make sure container_id is in the payload
    // const payload = {
    //   ...updateData,
    //   container_id: containerId,
    // };

    // return updateInventoryLoadSslSpec(payload)
    //   .then((res) => {
    //     notify('Container updated successfully!');
    //     console.log('res', res);
    //     // Refresh the data based on active tab
    //     // if (activeTab === 'dropped') {
    //     //   getInventoryList();
    //     // } else {
    //     //   getInventoryLoadList(true);
    //     // }
    //   })
    //   .catch((err) => {
    //     notify(err?.message || 'Failed to update container', 'warning');
    //   });
  };

  const columns = [
    { field: 'size', label: 'Size', align: 'center' },
    { field: 'ssl', label: 'SSL', align: 'center' },
    { field: 'name', label: 'Container', align: 'center' },
    { field: 'chases', label: 'Chassis', align: 'center' },
    { field: 'gated_out', label: 'Gated Out', align: 'center' },
    { field: 'location', label: 'Empty Location', align: 'center' },
    { field: 'lfd', label: 'LFD', align: 'center' },
    { field: 'chassesType', label: 'Chassis Type', align: 'center' },
  ];
  const cabinIsVerified = containerData[0]?.cabinIsVerified;
  const columnsCustomContainer = [
    {
      field: 'size',
      label: 'Size',
      align: 'center',
      flex: 1,
      component: (row) =>
        cabinIsVerified === 1 ? (
          row.size
        ) : (
          <div onClick={onClickeditSizeAndSsl} className={styles.cellContainer}>
            {row.size}
            <ReactSVG src={Icons.pen} />
          </div>
        ),
    },
    {
      field: 'ssl',
      label: 'SSL',
      align: 'center',
      flex: 1,
      component: (row) =>
        cabinIsVerified === 1 ? (
          row.ssl
        ) : (
          <div onClick={onClickeditSizeAndSsl} className={styles.cellContainer}>
            {row.ssl}
            <ReactSVG src={Icons.pen} />
          </div>
        ),
    },
    { field: 'name', label: 'Container', align: 'center', flex: 1 },
  ];
  const columnsCustomContainerWithoutSelect = [
    { field: 'size', label: 'Size', align: 'center' },
    { field: 'ssl', label: 'SSL', align: 'center' },
    { field: 'name', label: 'Container', align: 'center' },
  ];

  if (!appointmentData) {
    return <LoadingV2 />;
  }
  const handleAutoBookSetting = () => {
    setLoading(true);
    showAutoBookModalRef.current = true;
    setShowAutoBookModal(true);
    getAutobookID();
  };

  const getAutobookID = () => {
    if (autobookID === null) {
      AutoBookCreateContainer(apiData?.containerId)
        .then((res) => {
          const autobook_id = res?.data?.autobook_id;
          setAutobookID(res?.data?.autobook_id);
          if (autobook_id) {
            getAutobookPreferences(autobook_id);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setShowAutoBookModalWithRefresh(false);
          
        });
      return;
    } else {
      getAutobookPreferences(autobookID);
    }
  };

  const getAutobookPreferences = (autobook_id) => {
    setAutobookActiveSection('hour');

    if (autobook_id) {
      getAutoBookContainerData(autobook_id).then((res) => {
        const data = {
          id: res.autobook?.id || null,
          idx: 0,
          is_liveOnLoad:
            res?.autobook?.is_liveOnLoad === true
              ? 'Live Unload '
              : 'Drop & Pick' || '',
          number: res.autobook?.container_string || '',
          size: res.autobook?.specification?.size_type || '',
          type:
            `${res.autobook?.specification?.size_type},${res.autobook?.ssl?.name}` ||
            '',
          ssl: res.autobook?.ssl?.name || '',
          license: res.autobook?.license_plate || '',
          status: res.autobook?.status || '',
          lfd: res.autobook?.container?.last_free_day
            ? formatDateToUTC(res.autobook?.container?.last_free_day)
            : '',
          created_date: res.autobook?.created_at
            ? formatDateToUTC(res.autobook?.created_at)
            : '',
        };
        const AutobookAppointmentsApiData = {
          containerId: res.autobook?.container?.id || null,
          size: res.autobook?.specification?.id || '',
          ssl: res.autobook?.ssl?.id || '',
        };

        setAutobookMode({
          status: res.autobook?.status === 'ENABLED' ? true : false,
          autobookId: res.autobook?.id,
        });
        setAutobookModeapiRes({
          status: res.autobook?.status === 'ENABLED' ? true : false,
          autobookId: res.autobook?.id,
        });
        setAutobookTableData(data);
        setAutobookAppointmentsApiData(AutobookAppointmentsApiData);
        setAutobookSettings(res.autobook?.settings);
        setAutobookSavingIdentifier(res.autobook?.saving_identifier);
        setAutobookStatus(res.autobook?.status);
        setAutobookHistoryList(res.autobook?.event_history.reverse());
        setAutobookLoading(false);
        setLoading(false);
      });
    }
  };

  const sliderSettings = {
    className: 'slider variable-width',
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    initialSlide: 0,
    draggable: true,
    arrows: false,
    beforeChange: (current, next) => {
      const page =
        next > current
          ? activeSlide + 1
          : activeSlide === 0
          ? 0
          : activeSlide - 1;

      setActiveSlide(page);
    },
    appendDots: (dots) => (
      <div>
        <ul className="m-0"> {dots} </ul>
      </div>
    ),
    responsive: isAutobookPage
      ? [
          {
            breakpoint: 1330,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 2200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ]
      : [
          {
            breakpoint: 1974,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
  };

  return (
    <>
      <Modal
        minWidth={'unset'}
        show={showAutoBookModal}
        setShow={setShowAutoBookModalWithRefresh}
        icon={'AptAutobook'}
        title={'Autobook Preferences'}>
        <AutobookList
          parent={'inventory'}
          onAutobookModeChange={handleAutobookModeChange}
          loading={loading}
          setLoading={setLoading}
          tableData={autobookTableData}
          setTableData={setAutobookTableData}
          settings={autobookSettings}
          setSettings={setAutobookSettings}
          status={autobookStatus}
          setStatus={setAutobookStatus}
          autobookMode={autobookMode}
          setAutobookMode={setAutobookMode}
          setAutobookModeapiRes={setAutobookModeapiRes}
          autobookAppointmentsApiData={autobookAppointmentsApiData}
          setAutobookAppointmentsApiData={setAutobookAppointmentsApiData}
          saving_identifier={autobookSavingIdentifier}
          setSaving_identifier={setAutobookSavingIdentifier}
          historyList={autobookHistoryList}
          setHistoryList={setAutobookHistoryList}
          autobookLoading={autobookLoading}
          setAutobookLoading={setAutobookLoading}
          autobookModeLoading={autobookModeLoading}
          setAutobookModeLoading={setAutobookModeLoading}
          activeSection={autobookActiveSection}
          setActiveSection={setAutobookActiveSection}
          savedTemplates={autobookSavedTemplates}
          setSavedTemplates={setAutobookSavedTemplates}
          showSavePreferences={autobookShowSavePreferences}
          setShowSavePreferences={setAutobookShowSavePreferences}
          preferenceName={autobookPreferenceName}
          setPreferenceName={setAutobookPreferenceName}
          clickedTemplate={autobookClickedTemplate}
          setClickedTemplate={setAutobookClickedTemplate}
        />
      </Modal>
      {isAutobookPage ? (
        <>
          <div className={styles.PageContainerCards} ref={parentRef}>
            {Object.keys(appointmentSet).length > 0 && (
              <CardContainer
                style={{ paddingTop: '50px' }}
                title={
                  <>
                    <span>Booked Appointment</span>
                    <PaginationButtons
                      page={activeSlide}
                      totalPages={getTotalPages()}
                      setPage={setActiveSlide}
                      onPageChange={handlePageChange}
                    />
                  </>
                }>
                <div
                  className={styles.bookedContainer}
                  style={{ minHeight: '100px' }}>
                  <div style={{ zoom: isAutobookPage ? '0.72' : 'auto' }}>
                    <Slider
                      ref={(slider) => {
                        sliderRef = slider;
                      }}
                      {...sliderSettings}>
                      {Object.entries(sortedData).map(
                        ([terminalId, terminalAppointment]) => (
                          <div key={terminalId}>
                            <BookedCard
                              key={terminalId}
                              data={[terminalAppointment]}
                              containerId={apiData?.containerId}
                              setAppointmentSet={setAppointmentSet}
                              selectedStatus={selectedStatus}
                              terminalId={terminalId}
                              container={containerData[0]?.name}
                            />
                          </div>
                        )
                      )}
                    </Slider>
                  </div>
                </div>
              </CardContainer>
            )}

            <CardContainer
              isAutobookPage={isAutobookPage}
              title={
                appointmentSet.length > 0
                  ? 'Modify Your Appointment'
                  : 'Select a Return Appointment'
              }>
              <AppointmentTable
                isAutobookPage={isAutobookPage}
                parentRef={parentRef}
                data={appointmentData}
                cabinId={cabinId}
                containerId={apiData.containerId}
                containerName={containerData[0]?.name}
                setAppointmentSet={setAppointmentSet}
                shift={shift}
                appointmentSet={appointmentSet}
                noScroll={true}
                subTitle={
                  appointmentSet.length > 0
                    ? 'To reschedule, click the Edit button, then select a new available appointment from the table below.Your existing appointment will be updated once you confirm the change.'
                    : 'Choose an available return appointment from the table below. Click on an open slot to reserve a time at your preferred terminal.'
                }
                selectedStatus={selectedStatus}
              />
            </CardContainer>
            <Modal
              show={show}
              notClose={true}
              children={
                <EditAppointmentModal
                  containerData={containerData}
                  setShow={setShow}
                  SSLOptions={SSLOptions}
                  SizeOptions={sizeOptions}
                  SSL={apiData?.ssl}
                  Size={apiData?.size}
                  containerName={containerData[0]?.name}
                  editSizeAndSsl={editSizeAndSsl}
                  setEditSizeAndSsl={setEditSizeAndSsl}
                  getContainerDataHandler={getContainerDataHandler}
                />
              }
              icon={'pen'}
              title={'Edit Current Appointment'}
              setShow={setShow}
            />
          </div>
        </>
      ) : (
        <div className="overflow-x-auto">
          <PageContainerAB title={'Return Appointment'}>
            <div className={styles.PageContainerCards} ref={parentRef}>
              <CardContainer
                title={'Container Info'}
                titleRight={
                  <IconButton
                    onClick={handleAutoBookSetting}
                    icon={'AptAutobook'}
                    text={'AutoBook'}
                    color={autobookModeapiRes.status ? '#1FC16B' : '#131517'}
                    border={
                      autobookModeapiRes.status
                        ? '1px solid #1FC16B'
                        : '1px solid #131517'
                    }
                    size={'normal'}
                  />
                }>
                {window.location.hostname === 'testfront.smart-turn.com' ||
                window.location.hostname === 'localhost' ? (
                  <div className={styles.radios}>
                    <StatusSelector
                      selectedStatus={selectedStatus}
                      setSelectedStatus={setSelectedStatus}
                    />
                  </div>
                ) : (
                  ''
                )}
                <TableEx
                  onClickeditSizeAndSsl={onClickeditSizeAndSsl}
                  onClickeditSizeAndSslLoadContainers={
                    onClickeditSizeAndSslLoadContainers
                  }
                  columns={
                    columns
                      ? columns
                      : !containerData?.isLiveUnload
                      ? columnsCustomContainerWithoutSelect
                      : columnsCustomContainer
                  }
                  data={containerData || []}
                  totalCount={0}
                  keyField="id"
                  isLiveUnload={
                    apiData.isLiveUnload || containerData[0]?.isLiveUnload
                  }
                />
              </CardContainer>
              {Object.keys(appointmentSet).length > 0 && (
                <CardContainer
                  style={{ paddingTop: '50px' }}
                  title={
                    <>
                      <span>Booked Appointment</span>
                      <PaginationButtons
                        page={activeSlide}
                        totalPages={getTotalPages()}
                        setPage={setActiveSlide}
                        onPageChange={handlePageChange}
                      />
                    </>
                  }>
                  <div className={styles.bookedContainer}>
                    <Slider
                      ref={(slider) => {
                        sliderRef = slider;
                      }}
                      {...sliderSettings}>
                      {Object.entries(sortedData).map(
                        ([terminalId, terminalAppointment]) => (
                          <div key={terminalId}>
                            <BookedCard
                              key={terminalId}
                              data={[terminalAppointment]}
                              containerId={apiData?.containerId}
                              setAppointmentSet={setAppointmentSet}
                              selectedStatus={selectedStatus}
                              terminalId={terminalId}
                              container={containerData[0]?.name}
                            />
                          </div>
                        )
                      )}
                    </Slider>
                  </div>
                </CardContainer>
              )}
              <CardContainer
                title={
                  appointmentSet.length > 0
                    ? 'Modify Your Appointment'
                    : 'Select a Return Appointment'
                }>
                <AppointmentTable
                  isAutobookPage={isAutobookPage}
                  data={appointmentData}
                  cabinId={cabinId}
                  containerId={apiData.containerId}
                  containerName={containerData[0]?.name}
                  setAppointmentSet={setAppointmentSet}
                  shift={shift}
                  appointmentSet={appointmentSet}
                  noScroll={true}
                  subTitle={
                    appointmentSet.length > 0
                      ? 'To reschedule, click the Edit button, then select a new available appointment from the table below.Your existing appointment will be updated once you confirm the change.'
                      : 'Choose an available return appointment from the table below. Click on an open slot to reserve a time at your preferred terminal.'
                  }
                  selectedStatus={selectedStatus}
                />
              </CardContainer>
              <Modal
                show={show}
                notClose={true}
                children={
                  <EditAppointmentModal
                    setShow={setShow}
                    SSLOptions={SSLOptions}
                    SizeOptions={sizeOptions}
                    SSL={apiData?.ssl}
                    containerData={containerData}
                    Size={apiData?.size}
                    containerName={containerData[0]?.name}
                    editSizeAndSsl={editSizeAndSsl}
                    setEditSizeAndSsl={setEditSizeAndSsl}
                    getContainerDataHandler={getContainerDataHandler}
                  />
                }
                icon={'pen'}
                title={'Edit Current Appointment'}
                setShow={setShow}
              />
            </div>
          </PageContainerAB>
        </div>
      )}
    </>
  );
};
